import { render, staticRenderFns } from "./BrandCreateOrUpdate.vue?vue&type=template&id=12ba83fc&"
import script from "./BrandCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BrandCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports